export default "__VITE_PUBLIC_ASSET__18554f48__"